var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex border-b border-gray-400 pb-4"},[_c('input-radio-multi',{staticClass:"mt-4 flex-1",attrs:{"name":"property_type_class","value":_vm.property.property_type_class,"options":_vm.types,"wrap":true,"nullable":true,"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }